<ion-app appCspViolationReporter>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
